<template>
  <div>
    <el-dialog
      title="告警设置"
      :visible.sync="ruleVisible"
      width="940px"
      top="6vh"
      custom-class="alarm-setting-dialog"
      :close-on-click-modal="false"
      :show-close="!ruleSaving"
      :close-on-press-escape="!ruleSaving"
      @close="closeRuleSetting"
    >
      <el-tabs v-model="ruleScope" class="rule-tabs" @tab-click="onRuleScopeChange">
        <el-tab-pane label="账号默认" name="ACCOUNT" :disabled="ruleSaving" />
        <el-tab-pane label="车辆专属" name="VEHICLE" :disabled="ruleSaving" />
        <el-tab-pane label="运单专属" name="WAYBILL" :disabled="ruleSaving" />
      </el-tabs>
      <section v-if="ruleScope !== 'ACCOUNT'" class="scope-list">
        <div class="scope-toolbar">
          <el-input v-model.trim="scopeKeyword" :placeholder="ruleScope === 'VEHICLE' ? '搜索车牌号' : '搜索运单号'" clearable @keyup.enter.native="searchRuleScopes" />
          <el-button v-permission="'alarm:config'" :disabled="ruleSaving" @click="searchRuleScopes">查询</el-button>
          <el-button v-permission="'alarm:config'" type="primary" :disabled="ruleSaving" @click="openRuleCandidates">新建专属规则</el-button>
        </div>
        <el-table v-loading="scopeLoading" :data="scopeRows" border size="small">
          <el-table-column v-if="ruleScope === 'WAYBILL'" prop="waybillNo" label="运单号" min-width="160" />
          <el-table-column prop="vehicleNo" label="车牌号" min-width="130" />
          <el-table-column label="车牌颜色" width="110"><template slot-scope="{ row }">{{ plateColorLabel(row.plateColor) }}</template></el-table-column>
          <el-table-column label="操作" width="200"><template slot-scope="{ row }">
            <el-button v-permission="'alarm:config'" type="text" :disabled="ruleSaving" @click="editRuleScope(row)">编辑规则</el-button>
            <el-button v-permission="'alarm:config'" type="text" :disabled="ruleSaving" @click="restoreRuleInheritance(row)">恢复继承</el-button>
          </template></el-table-column>
        </el-table>
        <el-pagination :current-page="scopePage" :page-size="20" :total="scopeTotal" layout="total, prev, pager, next" @current-change="changeRuleScopePage" />
      </section>
      <section v-if="ruleEditorVisible" class="rule-editor">
        <div class="scope-source">{{ ruleScope === 'ACCOUNT' ? '账号默认规则' : ruleTargetLabel }} · 当前生效来源：{{ scopeLabel(ruleEffectiveScope) }}</div>
        <el-form :disabled="ruleLoading || ruleSaving || !ruleReady">

          <div v-loading="ruleLoading" class="setting-list">
            <div class="setting-row">
              <div class="setting-name">在途离线设置</div>
              <div class="setting-fields">
                <label>离线阈值<el-input-number v-model="ruleForm.offlineTime" :min="5" :max="999" controls-position="right" />分钟</label>
                <label>通知频率<el-input-number v-model="ruleForm.offlineNotice" :min="10" :max="300" :step="10" controls-position="right" />分钟</label>
              </div>
              <el-switch v-model="ruleForm.offlineSwitch" :active-value="0" :inactive-value="1" active-text="开" inactive-text="关" />
            </div>

            <div class="setting-row">
              <div class="setting-name">超时停车设置</div>
              <div class="setting-fields">
                <label>停车阈值<el-input-number v-model="ruleForm.otParkingTime" :min="5" :max="999" controls-position="right" />分钟</label>
              </div>
              <el-switch v-model="ruleForm.otParkingSwitch" :active-value="0" :inactive-value="1" active-text="开" inactive-text="关" />
            </div>

            <div class="setting-row">
              <div class="setting-name">线路偏离设置</div>
              <div class="setting-fields">
                <label>偏离半径<el-input-number v-model="ruleForm.lineDeviateWidth" :min="30" :max="5000" :step="10" controls-position="right" />米</label>
                <el-checkbox :value="Number(ruleForm.lineDeviateStop) === 0" @change="ruleForm.lineDeviateStop = $event ? 0 : 1">偏离且停车</el-checkbox>
                <label>通知频率<el-input-number v-model="ruleForm.lineDeviateNotice" :min="10" :max="300" :step="10" controls-position="right" />分钟</label>
              </div>
              <el-switch v-model="ruleForm.lineDeviateSwitch" :active-value="0" :inactive-value="1" active-text="开" inactive-text="关" />
            </div>

            <div class="setting-row">
              <div class="setting-name">晚发告警设置</div>
              <div class="setting-fields">
                <label>告警范围<el-input-number v-model="ruleForm.lateStartTimeBegin" :min="0" :max="10080" controls-position="right" />至</label>
                <label><el-input-number v-model="ruleForm.lateStartTimeEnd" :min="0" :max="10080" controls-position="right" />分钟</label>
                <el-checkbox :value="Number(ruleForm.lateStartAreaChk) === 0" @change="ruleForm.lateStartAreaChk = $event ? 0 : 1">校验起始地围栏</el-checkbox>
                <label>通知频率<el-input-number v-model="ruleForm.lateStartNotice" :min="10" :max="300" :step="10" controls-position="right" />分钟</label>
              </div>
              <el-switch v-model="ruleForm.lateStartSwitch" :active-value="0" :inactive-value="1" active-text="开" inactive-text="关" />
            </div>

            <div class="setting-row">
              <div class="setting-name">晚到告警设置</div>
              <div class="setting-fields">
                <label>告警范围<el-input-number v-model="ruleForm.lateTargetTimeBegin" :min="0" :max="10080" controls-position="right" />至</label>
                <label><el-input-number v-model="ruleForm.lateTargetTimeEnd" :min="0" :max="10080" controls-position="right" />分钟</label>
                <label>通知频率<el-input-number v-model="ruleForm.lateTargetNotice" :min="10" :max="300" :step="10" controls-position="right" />分钟</label>
              </div>
              <el-switch v-model="ruleForm.lateTargetSwitch" :active-value="0" :inactive-value="1" active-text="开" inactive-text="关" />
            </div>

            <div class="setting-row">
              <div class="setting-name">超速告警设置</div>
              <div class="setting-fields">
                <label>限速方式
                  <el-select v-model="ruleForm.overspeedType">
                    <el-option label="道路级限速" :value="0" />
                    <el-option label="手动限速" :value="1" />
                  </el-select>
                </label>
                <label v-if="Number(ruleForm.overspeedType) === 1">高速<el-input-number v-model="ruleForm.overspeedHighwayMin" :min="1" :max="150" controls-position="right" />km/h</label>
                <label v-if="Number(ruleForm.overspeedType) === 1">非高速<el-input-number v-model="ruleForm.overspeedRoadMax" :min="1" :max="150" controls-position="right" />km/h</label>
              </div>
              <el-switch v-model="ruleForm.overspeedSwitch" :active-value="0" :inactive-value="1" active-text="开" inactive-text="关" />
            </div>

            <div class="setting-row">
              <div class="setting-name">疲劳驾驶设置</div>
              <div class="setting-fields">
                <label>通知频率<el-input-number v-model="ruleForm.fatigueNotice" :min="10" :max="300" :step="10" controls-position="right" />分钟</label>
              </div>
              <el-switch v-model="ruleForm.fatigueSwitch" :active-value="0" :inactive-value="1" active-text="开" inactive-text="关" />
            </div>

          </div>
        </el-form>
      </section>
      <div class="setting-note">整套规则按运单专属 → 车辆专属 → 账号默认优先使用。保存后从下一次计算生效。</div>
      <span slot="footer">
        <el-button :disabled="ruleSaving" @click="ruleVisible = false">关闭</el-button>
        <el-button v-if="ruleEditorVisible" type="primary" :loading="ruleSaving" :disabled="ruleLoading || !ruleReady" v-permission="'alarm:config'" @click="onSubmitRule">保存规则</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="ruleScope === 'VEHICLE' ? '选择正常车辆' : '选择运单'" :visible.sync="candidateVisible" width="720px" append-to-body @close="closeRuleCandidates">
      <div class="scope-toolbar">
        <el-input v-model.trim="candidateKeyword" :placeholder="ruleScope === 'VEHICLE' ? '搜索车牌号' : '搜索运单号'" clearable @keyup.enter.native="searchRuleCandidates" />
        <el-button v-permission="'alarm:config'" @click="searchRuleCandidates">查询</el-button>
      </div>
      <el-table v-loading="candidateLoading" :data="candidateRows" border size="small">
        <el-table-column v-if="ruleScope === 'WAYBILL'" prop="waybillNo" label="运单号" min-width="160" />
        <el-table-column prop="vehicleNo" label="车牌号" min-width="130" />
        <el-table-column label="车牌颜色" width="110"><template slot-scope="{ row }">{{ plateColorLabel(row.plateColor) }}</template></el-table-column>
        <el-table-column v-if="ruleScope === 'WAYBILL'" label="运输状态" width="110"><template slot-scope="{ row }">{{ transportStatusLabel(row.transportStatus) }}</template></el-table-column>
        <el-table-column label="操作" width="80"><template slot-scope="{ row }"><el-button v-permission="'alarm:config'" type="text" @click="selectRuleCandidate(row)">选择</el-button></template></el-table-column>
      </el-table>
      <el-pagination :current-page="candidatePage" :page-size="20" :total="candidateTotal" layout="total, prev, pager, next" @current-change="changeRuleCandidatePage" />
    </el-dialog>
  </div>
</template>

<script>
import { getAlarmRule, saveAlarmRule, getAlarmScopes, getAlarmScope, saveAlarmScope, deleteAlarmScope, getAlarmScopeVehicles, getAlarmScopeWaybills, isRequestSuccess } from './lingdongApi'

const ruleFields = [
  'otParkingSwitch', 'otParkingTime', 'lateStartSwitch', 'lateStartTimeBegin', 'lateStartTimeEnd', 'lateStartAreaChk', 'lateStartNotice',
  'lateTargetSwitch', 'lateTargetTimeBegin', 'lateTargetTimeEnd', 'lateTargetNotice', 'lineDeviateSwitch', 'lineDeviateWidth', 'lineDeviateStop', 'lineDeviateNotice',
  'offlineSwitch', 'offlineTime', 'offlineNotice', 'overspeedSwitch', 'overspeedType', 'overspeedHighwayMin', 'overspeedRoadMax', 'fatigueSwitch', 'fatigueNotice'
]
function ruleValues(rule = {}) {
  return Object.fromEntries(ruleFields.map(key => [key, rule[key]]))
}

export default {
  name: 'AlarmRuleDialog',
  data() {
    return {
      ruleVisible: false,
      ruleLoading: false,
      ruleSaving: false,
      ruleScope: 'ACCOUNT',
      ruleRequest: 0,
      ruleReady: false,
      ruleEditorVisible: true,
      ruleTarget: null,
      ruleEffectiveScope: '',
      ruleForm: ruleValues(),
      scopeRows: [],
      scopeTotal: 0,
      scopePage: 1,
      scopeKeyword: '',
      scopeLoading: false,
      scopeRequest: 0,
      candidateVisible: false,
      candidateRows: [],
      candidateTotal: 0,
      candidatePage: 1,
      candidateKeyword: '',
      candidateLoading: false,
      candidateRequest: 0
    }
  },
  computed: {
    ruleTargetLabel() {
      if (!this.ruleTarget) return ''
      return this.ruleScope === 'WAYBILL' ? `运单：${this.ruleTarget.waybillNo}` : `车辆：${this.ruleTarget.vehicleNo}（${this.plateColorLabel(this.ruleTarget.plateColor)}）`
    }
  },
  beforeDestroy() {
    this.closeRuleSetting()
  },
  methods: {
    async open() {
      this.ruleVisible = true
      this.ruleScope = 'ACCOUNT'
      await this.onRuleScopeChange()
    },
    closeRuleSetting() {
      this.ruleRequest++
      this.scopeRequest++
      this.closeRuleCandidates()
      this.ruleLoading = false
      this.scopeLoading = false
      this.ruleSaving = false
    },
    async onRuleScopeChange() {
      this.ruleRequest++
      this.scopeRequest++
      this.closeRuleCandidates()
      this.ruleLoading = false
      this.scopeLoading = false
      this.ruleReady = false
      this.ruleTarget = null
      this.ruleEffectiveScope = ''
      this.ruleEditorVisible = this.ruleScope === 'ACCOUNT'
      this.scopePage = 1
      this.scopeKeyword = ''
      this.scopeRows = []
      this.scopeTotal = 0
      if (this.ruleScope !== 'ACCOUNT') return this.fetchRuleScopes()
      const requestId = ++this.ruleRequest
      this.ruleLoading = true
      try {
        const res = await getAlarmRule()
        if (requestId !== this.ruleRequest) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '告警设置查询失败')
        if (!res.data || ruleFields.some(key => res.data[key] == null)) throw new Error('未取得完整生效规则，请重试')
        this.ruleForm = ruleValues(res.data)
        this.ruleEffectiveScope = 'ACCOUNT'
        this.ruleReady = true
      } catch (error) {
        if (requestId === this.ruleRequest) this.$message.error((error && (error.msg || error.message)) || '告警设置查询失败')
      } finally {
        if (requestId === this.ruleRequest) this.ruleLoading = false
      }
    },
    async fetchRuleScopes() {
      const requestId = ++this.scopeRequest
      this.scopeLoading = true
      try {
        const res = await getAlarmScopes({ scopeType: this.ruleScope, keyword: this.scopeKeyword, page: this.scopePage, limit: 20 })
        if (requestId !== this.scopeRequest) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '专属规则查询失败')
        this.scopeRows = (res.data && res.data.items) || []
        this.scopeTotal = Number((res.data && res.data.total) || 0)
      } catch (error) {
        if (requestId === this.scopeRequest) this.$message.error((error && (error.msg || error.message)) || '专属规则查询失败')
      } finally {
        if (requestId === this.scopeRequest) this.scopeLoading = false
      }
    },
    searchRuleScopes() { this.scopePage = 1; return this.fetchRuleScopes() },
    changeRuleScopePage(page) { this.scopePage = page; return this.fetchRuleScopes() },
    openRuleCandidates() {
      this.candidateVisible = true
      this.candidatePage = 1
      this.candidateKeyword = ''
      this.candidateRows = []
      this.candidateTotal = 0
      return this.fetchRuleCandidates()
    },
    closeRuleCandidates() {
      this.candidateVisible = false
      this.candidateRequest++
      this.candidateLoading = false
    },
    async fetchRuleCandidates() {
      const requestId = ++this.candidateRequest
      this.candidateLoading = true
      try {
        const query = { keyword: this.candidateKeyword, page: this.candidatePage, limit: 20 }
        const res = await (this.ruleScope === 'VEHICLE' ? getAlarmScopeVehicles(query) : getAlarmScopeWaybills(query))
        if (requestId !== this.candidateRequest) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '候选查询失败')
        this.candidateRows = (res.data && res.data.items) || []
        this.candidateTotal = Number((res.data && res.data.total) || 0)
      } catch (error) {
        if (requestId === this.candidateRequest) this.$message.error((error && (error.msg || error.message)) || '候选查询失败')
      } finally {
        if (requestId === this.candidateRequest) this.candidateLoading = false
      }
    },
    searchRuleCandidates() { this.candidatePage = 1; return this.fetchRuleCandidates() },
    changeRuleCandidatePage(page) { this.candidatePage = page; return this.fetchRuleCandidates() },
    selectRuleCandidate(row) {
      this.closeRuleCandidates()
      const target = this.ruleScope === 'VEHICLE'
        ? { vehicleId: row.id, vehicleNo: row.vehicleNo, plateColor: row.plateColor }
        : { waybillId: row.id, waybillNo: row.waybillNo, vehicleNo: row.vehicleNo, plateColor: row.plateColor }
      return this.loadRuleScope(target)
    },
    editRuleScope(row) {
      return this.loadRuleScope({ id: row.id, waybillId: row.waybillId, waybillNo: row.waybillNo, vehicleNo: row.vehicleNo, plateColor: row.plateColor })
    },
    async loadRuleScope(target) {
      const requestId = ++this.ruleRequest
      this.ruleEditorVisible = true
      this.ruleReady = false
      this.ruleLoading = true
      const query = this.ruleScope === 'VEHICLE'
        ? { scopeType: 'VEHICLE', vehicleNo: target.vehicleNo, plateColor: target.plateColor }
        : { scopeType: 'WAYBILL', waybillId: target.waybillId }
      try {
        const res = await getAlarmScope(query)
        if (requestId !== this.ruleRequest) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '生效规则查询失败')
        const data = res.data
        if (!data || !data.rule || ruleFields.some(key => data.rule[key] == null)) throw new Error('未取得完整生效规则，请重试')
        if (target.id && !data.configured) throw new Error('规则已变更，请刷新列表后重新选择')
        this.ruleForm = ruleValues(data.rule)
        this.ruleTarget = { ...target, id: data.configured ? data.rule.id : null }
        this.ruleEffectiveScope = data.effectiveScope
        this.ruleReady = true
      } catch (error) {
        if (requestId === this.ruleRequest) this.$message.error((error && (error.msg || error.message)) || '生效规则查询失败')
      } finally {
        if (requestId === this.ruleRequest) this.ruleLoading = false
      }
    },
    async restoreRuleInheritance(row) {
      if (this.ruleSaving || this.ruleLoading) return
      const scope = this.ruleScope
      try { await this.$confirm('恢复继承后，下次计算使用下层整套规则，是否继续？', '恢复继承', { type: 'warning' }) } catch (_) { return }
      if (!this.ruleVisible || scope !== this.ruleScope || this.ruleSaving || this.ruleLoading) return
      const requestId = this.ruleRequest
      this.ruleSaving = true
      try {
        const res = await deleteAlarmScope(row.id)
        if (requestId !== this.ruleRequest) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '恢复继承失败')
        if (this.ruleTarget && String(this.ruleTarget.id) === String(row.id)) {
          this.ruleEditorVisible = false
          this.ruleReady = false
          this.ruleTarget = null
        }
        this.$message.success('已恢复继承')
        await this.fetchRuleScopes()
      } catch (error) {
        if (requestId === this.ruleRequest) this.$message.error((error && (error.msg || error.message)) || '恢复继承失败')
      } finally {
        if (requestId === this.ruleRequest) this.ruleSaving = false
      }
    },
    scopeLabel(scope) { return { ACCOUNT: '账号默认', VEHICLE: '车辆专属', WAYBILL: '运单专属' }[scope] || '加载中' },
    plateColorLabel(value) { return { 1: '蓝色', 2: '黄色', 3: '黄绿' }[value] || (value == null ? '未记录' : String(value)) },
    transportStatusLabel(value) { return { 0: '待开始', 1: '运输中', 2: '已完成', 3: '已作废', 4: '运单监控结束' }[value] || '未知状态' },
    validateRule() {
      if (Number(this.ruleForm.lateStartTimeBegin) > Number(this.ruleForm.lateStartTimeEnd)) {
        return '晚发最低阈值不能大于最高阈值'
      }
      if (Number(this.ruleForm.lateTargetTimeBegin) > Number(this.ruleForm.lateTargetTimeEnd)) {
        return '晚到最低阈值不能大于最高阈值'
      }
      const notices = [
        ['晚发通知频率', this.ruleForm.lateStartNotice],
        ['晚到通知频率', this.ruleForm.lateTargetNotice],
        ['偏离通知频率', this.ruleForm.lineDeviateNotice],
        ['离线通知频率', this.ruleForm.offlineNotice],
        ['疲劳通知频率', this.ruleForm.fatigueNotice]
      ]
      const invalidNotice = notices.find(item => Number(item[1]) < 10 || Number(item[1]) > 300 || Number(item[1]) % 10 !== 0)
      if (invalidNotice) return `${invalidNotice[0]}必须是10分钟的整数倍，且不能超过300分钟`
      return ''
    },
    async onSubmitRule() {
      if (this.ruleSaving || this.ruleLoading || !this.ruleReady) return
      const error = this.validateRule()
      if (error) {
        this.$message.warning(error)
        return
      }
      const requestId = this.ruleRequest
      const scope = this.ruleScope
      const payload = ruleValues(this.ruleForm)
      if (scope !== 'ACCOUNT') {
        payload.scopeType = scope
        if (this.ruleTarget.id) payload.id = this.ruleTarget.id
        else if (scope === 'VEHICLE') payload.vehicleId = this.ruleTarget.vehicleId
        else payload.waybillId = this.ruleTarget.waybillId
      }
      this.ruleSaving = true
      try {
        const res = await (scope === 'ACCOUNT' ? saveAlarmRule(payload) : saveAlarmScope(payload))
        if (requestId !== this.ruleRequest) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '保存失败')
        this.$message.success('告警设置保存成功')
        if (scope === 'ACCOUNT') this.ruleVisible = false
        else {
          this.ruleEditorVisible = false
          this.ruleReady = false
          await this.fetchRuleScopes()
        }
      } catch (error) {
        if (requestId === this.ruleRequest) this.$message.error((error && (error.msg || error.message)) || '告警设置保存失败')
      } finally {
        if (requestId === this.ruleRequest) this.ruleSaving = false
      }
    }
  }
}
</script>

<style scoped>
.rule-tabs ::v-deep .el-tabs__item { height: 48px; font-size: 16px; line-height: 48px; }
.setting-list { min-height: 420px; }
.setting-row { display: grid; grid-template-columns: 150px 1fr 74px; align-items: center; min-height: 68px; padding: 0 18px; border-bottom: 1px solid #eef1f6; }
.setting-row:last-child { border-bottom: 0; }
.setting-name { color: #475467; font-weight: 600; }
.setting-fields { display: flex; flex-wrap: wrap; align-items: center; gap: 12px 22px; }
.setting-fields label { display: flex; align-items: center; gap: 8px; color: #667085; white-space: nowrap; }
.setting-fields ::v-deep .el-input-number { width: 132px; }
.setting-fields ::v-deep .el-select { width: 150px; }
.setting-hint { color: #98a2b3; font-size: 13px; }
.scope-toolbar { display: flex; gap: 10px; margin: 12px 0; }
.scope-toolbar .el-input { max-width: 260px; }
.scope-list .el-pagination { margin: 12px 0; text-align: right; }
.scope-source { padding: 12px 18px; color: #409eff; background: #ecf5ff; }
.setting-note { padding: 12px 18px 0; border-top: 1px solid #eef1f6; color: #98a2b3; font-size: 13px; }
</style>
